var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_96",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 1H1V31H31V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_96)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_61_96",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 1H1V31H31V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_61_96)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3337 11.9998C21.3337 13.4143 20.7718 14.7708 19.7716 15.771C18.7714 16.7712 17.4149 17.3331 16.0004 17.3331C14.5859 17.3331 13.2293 16.7712 12.2291 15.771C11.229 14.7708 10.667 13.4143 10.667 11.9998C10.667 10.5853 11.229 9.22879 12.2291 8.22859C13.2293 7.2284 14.5859 6.6665 16.0004 6.6665C17.4149 6.6665 18.7714 7.2284 19.7716 8.22859C20.7718 9.22879 21.3337 10.5853 21.3337 11.9998ZM18.667 11.9998C18.667 12.707 18.3861 13.3853 17.886 13.8854C17.3859 14.3855 16.7076 14.6665 16.0004 14.6665C15.2931 14.6665 14.6149 14.3855 14.1148 13.8854C13.6147 13.3853 13.3337 12.707 13.3337 11.9998C13.3337 11.2925 13.6147 10.6143 14.1148 10.1142C14.6149 9.61411 15.2931 9.33316 16.0004 9.33316C16.7076 9.33316 17.3859 9.61411 17.886 10.1142C18.3861 10.6143 18.667 11.2925 18.667 11.9998Z",
    fill: "#FF573B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 1.33325C7.90016 1.33325 1.3335 7.89992 1.3335 15.9999C1.3335 24.0999 7.90016 30.6666 16.0001 30.6666C24.1001 30.6666 30.6668 24.0999 30.6668 15.9999C30.6668 7.89992 24.1001 1.33325 16.0001 1.33325ZM4.00016 15.9999C4.00016 18.7866 4.95083 21.3519 6.54416 23.3892C7.66314 21.9198 9.10669 20.7289 10.762 19.9096C12.4174 19.0904 14.2398 18.665 16.0868 18.6666C17.9099 18.6648 19.7094 19.0793 21.348 19.8783C22.9867 20.6773 24.4214 21.8398 25.5428 23.2772C26.6981 21.762 27.4759 19.9935 27.812 18.118C28.1481 16.2425 28.0327 14.3139 27.4755 12.4919C26.9182 10.6698 25.9351 9.00665 24.6075 7.63996C23.2798 6.27328 21.6458 5.24239 19.8407 4.63259C18.0355 4.02279 16.1111 3.85161 14.2266 4.13321C12.3422 4.41481 10.5519 5.1411 9.00385 6.25199C7.45582 7.36287 6.19458 8.82641 5.32447 10.5215C4.45436 12.2166 4.0004 14.0945 4.00016 15.9999ZM16.0001 27.9999C13.2454 28.004 10.5738 27.0564 8.43749 25.3172C9.2974 24.0862 10.4419 23.0811 11.7737 22.3875C13.1055 21.6938 14.5852 21.3322 16.0868 21.3332C17.5697 21.332 19.0315 21.6847 20.3507 22.3618C21.67 23.0389 22.8086 24.021 23.6721 25.2266C21.5192 27.0222 18.8036 28.0038 16.0001 27.9999Z",
    fill: "#FF573B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0581746bd2c6731921f3d5f3b7c66f51.svg";
export { ForwardRef as ReactComponent };